<template>
  <Section v-loading="loading" id="multiple-barcode-view">
    <div v-if="showBarcodes">
      <div class="inner-navbar">
        <el-form
          :inline="true"
          class="barcode-form-inline d-flex align-items-center"
        >
          <el-form-item label="No.of Copies">
            <el-input
              class="number-counter"
              type="number"
              min="1"
              max="100"
              placeholder="Enter no.of copies"
              v-model="barcodeCopies"
              @change="generateBarcodeCopies()"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :disabled="disablePrint"
              @click="onPrint"
              v-if="showPrint"
              :title="printButtonTitle"
              type="button"
              class="print-btn"
            >
              <span class="el-icon-printer"></span>Print Barcodes
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="inner-content">
        <div class id="barcodesBody">
          <div
            v-for="(caseId, index) in generatedCaseIds"
            :key="index"
            style="margin-top: 20px"
            class="each-barcode"
          >
            <div class="barcode">
              <div class="show-barcode">
                <el-row>
                  <el-col :span="24">
                    <div class="barcode-body" id="barcodeBody">
                      <div class="bar-code-table">
                        <div
                          class="bar-code-table-inner"
                          style="padding: 5px 10px"
                        >
                          <table
                            style="width: 100%; padding: 1em; max-width: 550px"
                          >
                            <tbody>
                              <tr style="vertical-align: baseline">
                                <th
                                  class="patient-name-block"
                                  style="
                                    text-align: left;
                                    text-transform: uppercase;
                                  "
                                >
                                  <div
                                    class="patient-name"
                                    v-if="
                                      caseInformationMap[caseId].patient_info
                                    "
                                  >
                                    {{
                                      caseInformationMap[caseId].patient_info
                                        .first_name
                                    }}
                                  </div>
                                  <div
                                    class="patient-name"
                                    v-if="
                                      caseInformationMap[caseId].patient_info
                                    "
                                  >
                                    {{
                                      caseInformationMap[caseId].patient_info
                                        .middle_name
                                        ? caseInformationMap[caseId]
                                            .patient_info.middle_name
                                        : ""
                                    }}
                                  </div>
                                  <div
                                    class="patient-name"
                                    v-if="
                                      caseInformationMap[caseId].patient_info
                                    "
                                  >
                                    {{
                                      caseInformationMap[caseId].patient_info
                                        .last_name
                                    }}
                                  </div>
                                </th>
                                <th class="date-column">
                                  <div class="dates">
                                    <p
                                      class="doc-dates"
                                      style="
                                        margin: 0;
                                        text-align: right;
                                        font-weight: 500;
                                      "
                                    >
                                      DOC:
                                      {{
                                        momentWithTimezone(
                                          caseInformationMap[caseId]
                                            .collection_date,
                                          "MM-DD-YYYY"
                                        )
                                      }}
                                    </p>
                                    <p
                                      class="dob-date"
                                      style="
                                        margin: 0;
                                        text-align: right;
                                        font-weight: 500;
                                      "
                                    >
                                      <span
                                        v-if="
                                          caseInformationMap[caseId]
                                            .patient_info
                                        "
                                      >
                                        DOB:
                                        {{
                                          dateWithMomentUTC(
                                            caseInformationMap[caseId]
                                              .patient_info.date_of_birth
                                          )
                                        }}
                                      </span>
                                    </p>
                                  </div>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <div class="content">
                            <el-row>
                              <el-col :span="24">
                                <div class="image">
                                  <BarcodeGenerator
                                    :value="caseInformationMap[caseId].order_id"
                                    font="arial"
                                    font-size="16"
                                    height="30"
                                    :width="1.4"
                                    display-value="false"
                                    :margin="0"
                                    v-if="caseInformationMap[caseId].order_id"
                                  ></BarcodeGenerator>
                                </div>
                                <div
                                  class="assession-id"
                                  style="
                                    text-align: center;
                                    font-size: 12.5px !important;
                                    font-weight: 600;
                                    letter-spacing: 0.15pt;
                                    line-height: 1;
                                    padding-bottom: 5px;
                                  "
                                >
                                  {{ caseInformationMap[caseId].order_id }}
                                </div>
                                <div class="case-types">
                                  <b>{{ trimmedCaseDetails(caseId) }}</b>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="no-barcode"
      v-if="
        !generatedCaseIds.length ||
        (!loading &&
          (!getMultipleBarcodeSources || !getMultipleBarcodeSources.length))
      "
    >
      <p>Unable to generate barcodes.</p>
    </div>
  </Section>
</template>

<script>
import { mapGetters } from "vuex";
import caseDataHelper from "@/mixins/caseDataHelper";

import BarcodeGenerator from "./BarcodeGenerator.vue";
import moment from "moment-timezone";
import caseConstants from "@/config/constants/caseConstants";

export default {
  mixins: [caseDataHelper],
  computed: {
    ...mapGetters("orders", [
      "getMultipleBarcodeSources",
      "getMultipleBarcodeStatus",
      "getCaseInformation",
    ]),
    ...mapGetters("profile", ["getProfileData"]),
    caseInformationMap() {
      if (
        !this.getMultipleBarcodeSources ||
        !this.getMultipleBarcodeSources.length
      ) {
        return {};
      }

      const data = {};

      this.getMultipleBarcodeSources.forEach((el) => {
        data[el.order_id] = el.order_information;
      });
      return data;
    },

    printButtonTitle() {
      return this.disablePrint ? "Wait until images are ready" : "";
    },

    trimmedCaseDetails() {
      return (caseId) => {
        let caseInfo = this.caseInformationMap[caseId];
        if (!caseInfo) return "";

        let caseName = this.caseTypesText(caseInfo.case_types);
        let coriellTests = caseInfo.coriell_test_panels || [];

        if (caseName === "UTI" && Array.isArray(coriellTests) && coriellTests.length > 0) {
          let testPanels = coriellTests
            .map(test => test.test_panels) 
            .flat() 
            .map(panel => caseConstants.UTI_MAPPING[panel] || panel) 
            .join(", "); 
          return testPanels;
        }
        return caseName ? caseName.slice(0, 35) : "";
      };
    }
  },
  components: {
    BarcodeGenerator,
  },
  async mounted() {
    await this.generateBarcodes();
  },
  data() {
    return {
      showBarcodes: false,
      showPrint: false,
      disablePrint: false,
      loading: false,
      caseIds: [],
      generatedCaseIds: [],
      barcodeCopies: 1,
    };
  },

  methods: {
    async generateBarcodes() {
      this.loading = true;
      let params = {};
      try {
        if (this.$route.query.order_ids) {
          const caseIds = this.$route.query.order_ids;
          if (caseIds) {
            params.order_ids = [];
            if (typeof caseIds == "string") {
              params.order_ids.push(caseIds);
            } else {
              params.order_ids = caseIds;
            }
          } else {
            this.loading = false;
            return;
          }
        } else if (this.$route.query.from_date && this.$route.query.to_date) {
          params.from_collection_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.$route.query.from_date))
            .startOf("day")
            .utc()
            .format();

          params.to_collection_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.$route.query.to_date))
            .endOf("day")
            .utc()
            .format();
        }
        params.key = "BAR_CODES";
        await this.$store.dispatch("orders/generateMultipleBarcodes", params);

        if (this.getMultipleBarcodeStatus) {
          this.getMultipleBarcodeSources.forEach((el) => {
            this.generatedCaseIds.push(el.order_id);
          });

          this.showBarcodes = true;
          this.showPrint = true;
          this.disablePrint = true;

          setTimeout(() => {
            this.disablePrint = false;
          }, 2000);
        } else {
          this.$notify({
            type: "Error",
            title: "Failed",
            message: "Failed to generate multiple barcodes",
          });
        }
        this.caseInfo = JSON.parse(JSON.stringify(this.getCaseInformation));
        // eslint-disable-next-line no-empty
      } catch (err) {
        console.log(err);
      }

      this.loading = false;
    },
    async onPrint() {
      window.print();
    },
    generateBarcodeCopies() {
      this.showBarcodes = false;
      if (this.getMultipleBarcodeStatus) {
        this.generatedCaseIds = [];
        for (let i = 1; i <= this.barcodeCopies; i++) {
          this.getMultipleBarcodeSources.forEach((el) => {
            this.generatedCaseIds.push(el.order_id);
          });
        }
      } else {
        this.$notify({
          type: "Error",
          title: "Failed",
          message: "Failed to generate multiple barcodes",
        });
      }
      this.showBarcodes = true;
    },
  },
  unmounted() {
    this.$store.dispatch("orders/resetGenerateMultipleBarcodes");
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap");
#multiple-barcode-view {
  padding: 2em 0;
  font-family: "Open Sans", sans-serif;
  @page {
    size: A4;
    margin: 0 auto;
    width: 288px;
    height: 192px;
  }
  .number-counter {
    .el-input__inner {
      padding-right: 0 !important;
      font-weight: 500;
      color: #000;
      font-size: 15px;
    }
  }
  .each-barcode {
    margin-top: 0 !important;
    page-break-inside: avoid;
    page-break-after: avoid;
  }
  .barcode-form-inline {
    .el-form-item {
      margin-bottom: 0;
    }
    margin-bottom: 45px;
  }
  #barcodeBody {
    .bar-code-table {
      width: 288px;
      margin: 4.85em auto;
      height: 192px;
      overflow: hidden;
      padding: 0;
      transform: rotate(90deg);
      table {
        padding: 10px 5px 10px 10px !important;
      }
      th {
        font-size: 14px;
      }
      .designation {
        margin-top: 0;
      }
      .dates {
        p {
          line-height: 20px;
          font-size: 13px;
        }
      }
      .image {        
        img {
          max-width: 200px;
          margin: 0 auto;
        }
        &.diasorin {
          img {
            max-width: 180px;
          }
        }
      }
    }
  }
  .inner-navbar {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    margin-right: 10px;
    .print-btn {
      background: #6f52ed;
      padding: 9px 15px;
      color: #fff;
      font-size: 1em;
      span {
        padding-right: 5px;
      }
    }
  }
  .inner-content {
    .bar-code-table {
      background: #fff;
      padding: 10px;
      .image {
        display: table;
        margin: 0 auto;
        max-width: 100% !important;
      }
      .case-types {
        text-align: center;
        b {
          font-size: 15px;
        }
      }
      table {
        margin: 0 auto;
      }
    }
  }
  .each-barcode {
    display: table;
    margin: 20px auto;
    margin-bottom: 20px;
  }
  @media print {
    .each-barcode {
      margin: 0 !important;
      display: block !important;
    }
    .inner-navbar {
      display: none !important;
      margin-top: 0 !important;
      margin-right: 0 !important;
    }
  }

  // @media print {
  #barcodeBody .bar-code-table {
    page-break-before: always;
    margin-bottom: 45px !important;
    margin-left: -48px !important;
    margin-right: 0 !important;
    background: #fff !important;
    margin-top: 48px !important;
    display: flex;
    align-items: flex-end;
  }
  .designation {
    margin-top: 0 !important;
    font-size: 8px !important;
  }
  #barcodeBody .bar-code-table .image img {
    margin-bottom: -5px;
  }
  #barcodeBody .bar-code-table #assession-id {
    text-align: center;
    font-size: 7pt !important;
    font-weight: 500;
    letter-spacing: 0.15pt;
    line-height: 1;
    padding-bottom: 0;
    margin-bottom: -20px;
  }
  #barcodeBody .bar-code-table th {
    font-size: 7px !important;
    font-weight: normal;
    letter-spacing: 0.1px;
  }
  #barcodeBody .bar-code-table .patient-name-block {
    padding-top: 10px;
  }
  #barcodeBody .bar-code-table .date-column {
    width: auto;
  }
  #barcodeBody .bar-code-table .patient-name {
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 2px;
    word-wrap: break-word;
    width: 105px;
    letter-spacing: 0;
  }
  #barcodeBody .bar-code-table .dates {
    font-size: 8pt;
    font-weight: 700;
    padding-right: 10px;
  }
  #barcodeBody .bar-code-table .dates p {
    line-height: 16px;
    font-size: 12px !important;
    font-weight: 800;
    letter-spacing: 0.2px;
  }
  .inner-content .bar-code-table .case-types b {
    font-size: 12.5px !important;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 18px;
    padding-top: 0;
    margin: -10px 0 0 !important;
  }
  .bar-code-table-inner {
    width: 100%;
    padding: 15px 10px 15px 15px !important;
    overflow: hidden;
  }
  .patient-name-block {
    padding-left: 10px;
  }
  padding-top: 0 !important;

  #multiple-barcode-view {
    padding-top: 0;
  }
}
.no-barcode {
  text-align: center;
  font-size: 1.1em;
}
.bar-code-table-inner {
  padding-bottom: 10px !important;
}
#multiple-barcode-view .inner-content .bar-code-table .case-types {
  line-height: 10px;
}
</style>
